import React, { PureComponent } from 'react'
import { Container } from 'react-bootstrap'
import { Helmet } from 'react-helmet'
import { FaArrowRight } from 'react-icons/fa'
import { Link } from 'react-router-dom'
import RwPayLogo from '../../assets/img/rosswarepay/full_logo.svg'
import SavingsIcon from '../../assets/icons/save-money.svg'
import HomeIcon from '../../assets/icons/home.svg'
import SpeedIcon from '../../assets/icons/speed.svg'
import PaymentsCustomer from '../../assets/images/payments-customer.jpg'
import GetDemo from '../../components/CTAs/GetDemo'

class RosswarePay extends PureComponent {
    render() {
        return (
            <div>
                <Helmet>
                    <title>Payment Processing - RosswarePay</title>
                    <meta name="fragment" content="!"></meta>
                    <meta name="description" content="RosswarePay is Rossware's integrated payment processing solution." />
                    <meta property="og:title" content="Payment Processing - RosswarePay" />
                    <meta property="og:image" content="path/to/image.jpg" />
                </Helmet>
                <div className="section">
                    <Container className="">
                        <div className="grid-2-col md-gap">
                            <div className="d-flex flex-column justify-content-center align-items-left">
                                <div className="pre-text">Payment Processing</div>
                                <h1 className="h2">Introducing the future of payments</h1>
                                <p className="pb-4">Get competitive rates, world-class support, the newest terminals, and the very best integration with Rossware software.</p>
                                <div>
                                    <Link className="btn btn-primary btn-icon-right mr-5" to="/rosswarepay-signup">Get started now <FaArrowRight /></Link>
                                </div>
                            </div>
                            <img src={RwPayLogo} style={{ marginTop: '70px', minWidth: '300px', minHeight: '50px' }} alt="RosswarePay Logo" />
                        </div>
                    </Container>
                </div>
                <section className="">
                    <div className="container">
                        <div className="grid-2-col md-gap">
                            <div>
                                <img src={PaymentsCustomer} width="100%" alt="Call management with Call Sheets" className="hero-image-right"></img>
                            </div>
                            <div className="feature-text">
                                <div className="grid-rows">
                                    <h3 className="h2">Say goodbye to third-party hassles</h3>
                                    <p>Rossware comes with payments built right in — no more clunky integrations or waiting forever on the phone.</p>
                                    <div className="grid-3-col">
                                        <div className="bg-primary-dark text-white p-4 rounded shadow-sm">
                                            <img src={HomeIcon} alt="Savings Icon" width="40px" className="mb-3"></img>
                                            <p className="lead mb-0 text-white">Integrated into our apps</p>
                                        </div>
                                        <div className="bg-primary-dark text-white p-4 rounded shadow-sm">
                                            <img src={SavingsIcon} alt="Savings Icon" width="40px" className="mb-3"></img>
                                            <p className="lead mb-0 text-white">Lower processing costs</p>
                                        </div>
                                        <div className="bg-primary-dark text-white p-4 rounded shadow-sm">
                                            <img src={SpeedIcon} alt="Savings Icon" width="40px" className="mb-3"></img>
                                            <p className="lead mb-0 text-white">Faster processing</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            
                        </div>
                    </div>
                </section>
                <div className="section bg-white">
                    <Container>
                        <div className="grid-2-col mb-4 md-gap">
                            <div className="h-100 d-flex flex-column justify-content-center">
                                <h3>Competitive rates</h3>
                                <p className="">Rossware has worked closely with our payment services provider to provide the best in class payments solution.</p>
                            </div>
                            <div className="h-100 d-flex flex-column justify-content-center">
                                <h3>Exceptional Customer Support</h3>
                                <p className="">Support of RosswarePay is provided by the Rossware team you already know and love! Don't spend any more time in frustrating phone trees waiting to be helped.</p>
                            </div>
                        </div>

                        <div className="grid-2-col mb-4 md-gap">
                            <div className="h-100 d-flex flex-column justify-content-center">
                                <h3>Terminals</h3>
                                <p className="">We are now able to bring you the best in payments terminals, integrated without all the connection glitches you've struggled with through other processors.</p>
                                <p className="">Check out our <a href="https://help.rossware.com/en/articles/731840">help doc on reader support</a> for the most up-to-date information.</p>
                            </div>
                            <div className="h-100 d-flex flex-column justify-content-center">
                                <h3>Accounting &amp; reconciliation</h3>
                                <p className="">One huge advantage to running your payments through RosswarePay is having all of your data in one place. Save valuable time with automated reconciliation.</p>
                                <p className="">Additionally, you'll be able to access all your payments information <a href="https://dashboard.rossware.com">right here through your Rossware Dashboard.</a></p>

                            </div>
                        </div>

                        <div className="grid-2-col mb-4 md-gap">
                            <div className="h-100 d-flex flex-column justify-content-center">
                                <h3>Tips/Gratuities</h3>
                                <p className="">Allow your technicians to collect tips from customers for a job well done!</p>
                            </div>
                            <div className="h-100 d-flex flex-column justify-content-center">
                                <h3>Platform fee</h3>
                                <p className="">Charge your clients a percentage of each transaction to help cover your internal costs.</p>

                            </div>
                        </div>
                    </Container>
                </div>
                <GetDemo />
            </div>

        )
    }
}

export default RosswarePay